import React from 'react';
import Footer from '../../pages/Shared/Footer/Footer';
import Navbar from '../../pages/Shared/Navber/Navbar';
import { Outlet } from 'react-router-dom';


const Main = () => {
    return (
        <div>
            <Navbar></Navbar>
            <Outlet></Outlet>
            <Footer></Footer>

        </div>
    );
};

export default Main;